<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">基本信息</div>
      </div>
      <div>
        <span>采摘批次：</span>
        <span>{{ }}</span>
      </div>
    </div>

    <el-form :model="formData" ref="form" :rules="rules" label-width="auto" label-suffix="：">
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item label="果园编号">
            <el-input v-model="formData.remark" placeholder="请输入" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item label="果园名称">
            <el-input v-model="formData.remark" placeholder="请输入" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item label="果园区域">
            <el-input v-model="formData.remark" placeholder="请输入" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item label="果园定位">
            <el-input v-model="formData.remark" placeholder="请输入" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item label="监园人员">
            <el-select
              v-model="formData.supplierId"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in productNameList"
                :key="index"
                :label="item.supplierName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item label="采摘日期">
            <el-date-picker v-model="formData.supplierId" type="date" placeholder="选择日期"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24" :xs="12">
          <el-form-item :label="'备注'">
            <el-input
              type="textarea"
              :rows="3"
              v-model="formData.remark"
              placeholder="300字以内"
              v-if="type != 'preview'"
            ></el-input>
            <span v-else>{{ formData.remark ? formData.remark : '-' }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'TaskPickForm',
  components: {
  },
  props: {
    dataata: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
    },
  },
  data() {
    return {
      importHeaders: '',
      uploadPath: '',
      colLists: [
        {
          prop: 'code',
          label: '培育方式',
          isTrue: true,
        },
        {
          prop: 'oilCode',
          solt: true,
          label: '成熟度',
          isTrue: true,
        },
        {
          prop: 'createTime',
          label: '计划采购总净重(斤)',
          isTrue: true,
        },

        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
      formData: { attachments: [] },
      rules: {},

      productNameList: [],
    }
  },
  methods: {
    beforeAvatarUpload() {},
    handleAvatarError() {},
    handlePropress() {},
    handleAvatarSuccess() {},
    handleDel() {},
    handleDelFile() {},
  },
}
</script>

<style scoped lang='less'>
@import '../../../../assets/form.less';
::v-deep {
  .no-contract-type {
    padding: 30px;
    background-color: #f8f8f8;
    border-radius: 12px;
    text-align: center;
    border: 1px solid #dde4ff;
    margin-bottom: 20px;
  }
}
</style>